import { useCallback } from 'react'
import copy from 'copy-to-clipboard'
import { SketchElement, SketchLayerCSSProperties } from '@sketch/scene-model'
import { useGenerateLayerCSS } from './useGenerateLayerCSS'

/**
 * The generated CSS for an element, plus a handler that copies it.
 *
 * The sidebar's CSS section, the CSS preview modal and the canvas context menu
 * all offer "copy this layer's CSS", and each had its own copy of
 * `useGenerateLayerCSS` + guard + `copy(layerCSS.toString())`.
 */
export function useCopyLayerCSS(
  element?: SketchElement | SketchLayerCSSProperties
) {
  const layerCSS = useGenerateLayerCSS(element)

  const copyLayerCSS = useCallback(() => {
    if (!layerCSS.css.length) return false
    copy(layerCSS.toString())
    return true
  }, [layerCSS])

  return { layerCSS, copyLayerCSS }
}
